import * as React from "react";

const GreenTriangle = (props: any) => (
  <svg
    width={46}
    height={43}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 42.275 22.966 0l22.835 28.208L0 42.275Z"
      fill="#67EBB2"
    />
  </svg>
);

export default GreenTriangle;
